<template>
  <div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">中再生双江智慧环卫系统</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <!-- <div class="model"> -->
        <!-- <div class="model_title">【企业介绍】</div> -->
        <!-- <div class="section"></div> -->
        <!-- </div> -->
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div>
            <div class="section">
              城市环境卫生管理是一项复杂而系统的社会工程，不仅是一个城市的“脸面”也是一个城市的文明程度的重要标志。是与人民群众生活最直接、最贴切、最敏感的重要工作之一，随着城市人民生活水平的快速提高，大家对居住、生活环境的要求越来越高，为进一步提高环境卫生管理水平，树立城市形象，提升城市品位，必须采取切实可行的措施，加强对城市环境卫生管理。
            </div>
            <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail1/1.png" alt="" />
            </div>
          </div>

          <div>
            <div class="section">
               坚持高效能的管理，全面提高城市环卫工作质量和水平。做好城区环卫工作，为人民群众创造一个良好的生活环境，是关注民生，构建社会主义和谐社会的客观要求。也是为人民群众办实事、办好事。其中管理是提高城市环卫工作质量、塑造环卫行业形象的重要基础工作，也是目前工作中的相对薄弱环节。在建立健全并严格落实各项管理制度的同时进一步建立和完善环卫作业标准、服务规范、工作程序和考核奖惩细则，严格实行全员岗位责任制，大力推行精细化管理。
            </div>
            <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail1/2.png" alt="" />
            </div>
          </div>

          <div>
            <div class="section">
              环卫市场需要向智能化、信息化、精细化、一体化方向发展，智能化已经成为行业发展的新趋势，桑德、昌邑康洁等业内企业纷纷推出互联网环卫、智慧环卫等模式。智慧化环卫依托物联网技术，实现了对环卫工人和环卫设备的实时监控，可以及时分配任务、提高突发事件应急能力，大大提高企业管理效率，有效降低管理成本。除了提升传统作业效果，智慧环卫还给传统环卫商业模式带来了新的可能，例如结合互联网实施物流快递、设备广告位出租附加业务等。
            </div>
            <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail1/3.png" alt="" />
            </div>
             <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail1/4.png" alt="" />
            </div>

          </div>

        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            建立一套环卫工作全范围管控体系，通过GPS定位技术、地理信息技术GIS、视频监控技术、大数据挖掘分析等技术实现的城市环卫工作的智能化管理，可以切实达到“对指定的车辆和人员、沿指定的路线、在规定的时间内、到达指定的位置”，支持管理人员对城市环境卫生管理的及时发现、及时跟踪处理，做到主动预防并辅助管理人员在计划、执行与跟踪、考核、标准化等环节的受控管理。
          </div>
          <div class="section">
            基于物联网技术与移动互联网技术,对环卫管理所涉及到的人、车、物、事进行全过程实时管理,合理设计规划环卫管理模式,提升环卫作业质量,降低环卫运营成本。大幅度提高环卫作业工作的规范化及科学化水平，杜绝对环卫作业无法科学、准确的考核和有效的监控现象，为城市环卫工作提供最有效的解决方案。
          </div>
          <div class="section">
            确保清扫作业效果，杜绝空驶行为
            保证道路清扫车、洒水车在作业时间、作业路段内一定是开启清扫和洒水操作，如出现空驶情况将第一时间发现并处理，实现环卫机械化作业全过程实时化、可视化监控。
          </div>
          <div class="section">
            提高清扫作业效率，防止司机偷懒行为
            保证清扫作业时间内全额作业，如在作业时间内长时间停驶将第一时间预警并核实确认。
          </div>

           <div class="section">
            提升清扫作业质量，降低作业不达标率
            驾驶员及监管中心能在第一时间了解作业质量，对未清扫到位的路段实时掌握并及时处理。
          </div>
          <div class="section">
            精确掌握作业人员数量及状态
            实现城区环卫作业工人作业质量、人员到岗情况的监管和考核，对市场化作业保洁人员进行精细化管理，对上岗状况进行实时监测，确保招标定额人员都配置到位并上岗作业。
          </div>
          <div class="section">
            有效提高人员作业质量
            对人员实时作业位置、作业状况进行在线监管，保证人员按规定时间、范围进行作业保洁，确保作业质量
          </div>
          <div class="section">
            实现生活垃圾清运过程高效、规范
            对清运车辆运输全过程、进出中转站的状况进行可视化监管，实时掌握车辆运行情况，杜绝不按规定路线收集清运、超速作业等问题。
          </div>

          <div class="section">
            确保垃圾转运效率，提升收集转运站形象
            监督车辆按规定时间和次数到达收集转运站进行收集和转运作业，确保垃圾及时转运，对未及时收集转运的收集站进行在线调度解决。另一方面实时掌握各收集、转运站的作业现场状况，对脏乱、违规作业等行为及时处理。
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseZhongZaiShengDetail1",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        // padding-left: 2.0em;
        img {
          width: 2.4rem;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseZhongZaiShengDetail1.vue